export const COMPANY_NAME = "All Clear Pool Services Inc.";
export const COMPANY_SHORT = "All Clear Pool Services";
export const COMPANY_INITIALS = "ACP";
export const COMPANY_ADDRESS_FULL = "18017 Chatsworth St, Granada Hills, California, US 91344-5608";
export const COMPANY_LOCATION = "Granada Hills, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=18017%20Chatsworth%20St%2C%20Granada%20Hills%2C%20California%2C%20US%2091344-5608";
export const ABOUT_IMAGE_URL = "/assets/all-clear-pool.png";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Pool services" },
  { "label": "Service area", "value": "Los Angeles County" },
  { "label": "Location", "value": "Granada Hills, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "All Clear Pool Services Inc." },
  { "label": "Area", "value": "Granada Hills, California" },
  { "label": "Address", "value": "18017 Chatsworth St, Granada Hills, California, US 91344-5608" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Pool care", "body": "A clear, simple profile for pool-service inquiries." },
  { "icon": "✦", "title": "Local presence", "body": "Located in Granada Hills within Los Angeles County." },
  { "icon": "✿", "title": "Thoughtful service", "body": "A calm starting point for learning about the organization." },
  { "icon": "❍", "title": "Plan a visit", "body": "Use the address below to find the business location." },
];
